import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function formatPhoneNumber(phoneNumberInput: string | number | undefined): string {
  if (!phoneNumberInput) {
    return '';
  }

  let phoneNumberString = typeof phoneNumberInput === 'number' ? phoneNumberInput.toFixed(0) : phoneNumberInput.toString();
  // Remove spaces, dashes, parentheses
  phoneNumberString = phoneNumberString.replace(/[^\d+]/g, '');
  // Handle numbers starting with '+1' (US country code)
  if (phoneNumberString.startsWith('+1') && phoneNumberString.length === 12) {
    phoneNumberString = phoneNumberString.slice(2);
  } else if (phoneNumberString.startsWith('1') && phoneNumberString.length === 11) {
    phoneNumberString = phoneNumberString.slice(1);
  }
  if (phoneNumberString.length === 10) {
    const phoneNumber = parsePhoneNumberFromString(phoneNumberString, 'US');
    if (phoneNumber) {
      return phoneNumber.formatNational();
    }
  }
  return FormatPhoneNumberCustom(phoneNumberString);
}

export function FormatPhoneNumberCustom(num: string): string {
  if (num.length < 10) {
    if (num.length <= 3) {
      return num;
    } else if (num.length <= 6) {
      return `(${num.slice(0, 3)}) ${num.slice(3)}`;
    } else {
      return `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6)}`;
    }
  }

  const formattedNumber = `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6)}`;
  return formattedNumber;
}

export default formatPhoneNumber;